var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6924 22.4602H33.9758V23.6739H32.6924V22.4602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7998 33.3691H21.7839V34.5828H12.7998V33.3691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3662 35.936H16.6497V37.1497H15.3662V35.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8661 30.7675H34.6524V28.8074H32.6924V27.5938H35.8661V30.7675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1768 8.30762H22.3904V9.59106H21.1768V8.30762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1768 5.74072H22.3904V7.02416H21.1768V5.74072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78056 26.2405H22.4253V25.0268H1.21368V23.6736H28.8422V22.4599H1.54057L3.56817 17.8983H17.4977L20.5 20.686L23.5023 17.8983H28.8422V16.6846H24.8092L31.029 10.9093H26.2406V4.45703H25.0269V10.9093H21.1416V12.1226H27.9391L21.1068 18.4669V13.4411H19.8932V18.4669L13.0612 12.1226H15.9731V9.59079H14.7594V10.9093H9.97098L16.1908 16.6846H2.77927L0 22.9379V26.2405H2.56688V40.9999H13.4412V39.7862H3.78056V26.2405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 22.9379L38.2207 16.6846H30.7675V17.8983H37.4318L39.7863 23.1956V25.0268H24.3503V26.2405H37.2194V39.7862H15.3662V40.9999H38.4331V26.2405H41V22.9379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.126 22.4602H31.4094V23.6739H30.126V22.4602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2598 22.4602H36.5432V23.6739H35.2598V22.4602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8394 37.7915V32.7275H5.77539V37.7915H10.8394ZM6.98907 33.9412H9.62571V36.5779H6.98907V33.9412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7998 35.936H14.0832V37.1497H12.7998V35.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9734 1.21368H25.0273V2.53185H26.241V0H14.7598V7.6656H15.9734V1.21368Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientIcon);
export default __webpack_public_path__ + "static/media/recipient-icon.d62cfba18dcc322fe9746a22e97e9607.svg";
export { ForwardRef as ReactComponent };